<app-base-list-page
  [headersList]="headerList"
  (rowClick)="agreementClicked($event)"
  [extraBurgerMenuOptions]="extraBurgerMenuOptions"
  [multiSelectFilterLists]="multiSelectFilterLists"
  [createNew]="agreementClicked"
  newItemLabel="Ny Kunde"
  #baseListPage
></app-base-list-page>
